import * as React from 'react';

import ConsumerLoggedOutHomePageHeader from 'bundles/composable-page-header-consumer/header-renderers/ConsumerLoggedOutHomePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import FrontPageContent from 'bundles/front-page/pages/FrontPageContent';
import { useAiAssistanceExperimentData } from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import FrontPageDataProvider from 'bundles/front-page/providers/FrontPageDataProvider';
import CoachChatContainer from 'bundles/front-page/redesign-modules/ai-assistance/CoachChatContainer';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

const FrontPageInner = () => {
  const { aiAssistanceEnabled } = useAiAssistanceExperimentData();
  const headerRef = React.useRef<HTMLSpanElement>(null);
  const footerRef = React.useRef<HTMLDivElement>(null);

  return (
    <React.Fragment>
      <span ref={headerRef}>
        <ConsumerLoggedOutHomePageHeader />
      </span>
      <UniversalPageFeatures />
      <FrontPageContent />
      <PageFooter elRef={footerRef} />
      {aiAssistanceEnabled && <CoachChatContainer headerRef={headerRef} footerRef={footerRef} />}

      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />
      <FrontPageGoogleSchemaMarkup />
    </React.Fragment>
  );
};

const FrontPage = () => {
  return (
    <FrontPageDataProvider>
      <FrontPageInner />
    </FrontPageDataProvider>
  );
};

export default FrontPage;
